export default __webpack_public_path__ + "static/miracle-mask-mobile-e1c0e478823bfa33358da033ea57d402.mp4";